import { API_BASE_URL } from '../config.js';

export const API_ENDPOINTS = {
  FONT_OPENSANS: `${API_BASE_URL}/api/fonts/open-sans`,
  PROGRAMS: `${API_BASE_URL}/api/programs`,
  COURSES: `${API_BASE_URL}/api/courses`,
  DRIVE_UPLOAD_PDF: `${API_BASE_URL}/drive/upload-pdf`,
};


